import { Navigate, Outlet, useSearchParams } from 'react-router'
import appConfig from '@/configs/app.config'
import { REDIRECT_URL_KEY } from '@/constants/app.constant'
import { useAuth } from '@/auth'

const { authenticatedEntryPath } = appConfig

const PublicRoute = () => {
    const { authenticated } = useAuth()
    const [params] = useSearchParams()

    // When an already-authed user lands on a public route that carries a
    // redirectUrl (e.g. /sign-in?redirectUrl=/trash after the auth-bootstrap
    // race), send them to that page instead of the default entry — so a hard
    // load / shared link to a protected route ends up where it was headed.
    const redirectUrl = params.get(REDIRECT_URL_KEY)
    const target =
        redirectUrl && redirectUrl.startsWith('/') ? redirectUrl : authenticatedEntryPath

    return authenticated ? <Navigate to={target} replace /> : <Outlet />
}

export default PublicRoute
